// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { never } from "grpc-web-rx"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  AddFavouriteTimesheetFieldOptionRequest,
  ListFavouriteTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type AddFavouriteTimesheetFieldOptionRpc = (request: AddFavouriteTimesheetFieldOptionRequest) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const addFavouriteTimesheetFieldOption = (addFavouriteTimesheetFieldOptionRpc: AddFavouriteTimesheetFieldOptionRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.addFavouriteTimesheetFieldOption.match),
      mergeMap((action) => of(action.payload)
        .pipe(
          mergeMap(addFavouriteTimesheetFieldOptionRpc),
          map(response => ({ siteId: action.payload.getSiteId(), options: response.toObject().timesheetFieldOptionsList })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_add_favourite_timesheet_field_option_failed",
              message: "Failed to favourite timesheet field option. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const addFavouriteTimesheetFieldOptionRpc = (request: AddFavouriteTimesheetFieldOptionRequest): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  grpc(() => timesheetFieldClient.addFavouriteTimesheetFieldOption(request, null), never)

export default addFavouriteTimesheetFieldOption(addFavouriteTimesheetFieldOptionRpc)
